import React, { useEffect } from "react";
import "../css/privacy.scss";

function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="main-content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Cookie Policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>Last updated: 7 September 2026</p>
            <p>
              This policy explains how Pedarcircle may use cookies and similar
              technologies when you visit pedarcircle.club.
            </p>

            <h2>What cookies are</h2>
            <p>
              Cookies are small text files stored on your device by a website.
              Similar technologies, such as local storage, may also remember
              information between pages or visits.
            </p>

            <h2>How we use them</h2>
            <ul>
              <li>
                <strong>Strictly necessary:</strong> to provide core features,
                keep the site secure and support checkout.
              </li>
              <li>
                <strong>Preferences:</strong> to remember choices you make when
                those features are available.
              </li>
              <li>
                <strong>Analytics:</strong> to understand site performance and
                usage if analytics tools are enabled with the required consent.
              </li>
              <li>
                <strong>Marketing:</strong> to measure campaigns or personalise
                advertising only if these tools are enabled and you consent.
              </li>
            </ul>

            <h2>Third-party services</h2>
            <p>
              Checkout, payment, embedded content or other service providers may
              set their own cookies when their features are used. Their handling
              of information is governed by their own privacy notices.
            </p>

            <h2>Managing cookies</h2>
            <p>
              You can delete or block cookies using your browser settings. Some
              essential site functions may not work correctly if necessary
              storage is blocked. Where a consent control is shown, you can use
              it to change your optional-cookie choices.
            </p>

            <h2>Contact us</h2>
            <p>
              For questions about this Cookie Policy, email {" "}
              <a href="mailto:draft@pedarcircle.club">
                draft@pedarcircle.club
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default CookiePolicy;
